import { IApplicationState } from '../../types/redux';
import { isFsk } from '../../utils';
import { getDeveloper } from '../developer';

export function checkFsk(state: IApplicationState): boolean {
  const developer = getDeveloper(state);

  return !!developer && isFsk(developer.specProjectType);
}
